import React, { FC } from 'react'

import { IconDocumentXlsProps } from './IconDocumentXls.types'
import * as Styled from './styles/IconDocumentXls.style'

import { nonThemeableRules } from '../../ruleSet'

const IconDocumentXls: FC<IconDocumentXlsProps> = ({
  size = nonThemeableRules.defaultSize as number as IconDocumentXlsProps['size'],
  isResponsive = false,
}: IconDocumentXlsProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#3208399c-7f18-48d6-b1e5-a616fb8263fa__a)' strokeLinecap='round' strokeWidth='2'>
          <path d='M11.498 13.002h7.53V6' stroke='#0D0D0D' strokeLinejoin='round' />
          <path
            d='M20.75 5.06a4.265 4.265 0 0 0-2.775 1.028l-5.42 4.64a4.249 4.249 0 0 0-1.485 3.232v24.93c0 2.2 1.8 4 3.48 4H33c2.72 0 4-1.8 4-4V5.06H20.75Z'
            stroke='#0D0D0D'
            strokeMiterlimit='10'
          />
          <path
            d='M22.865 22.932v6.075h3.038m-10.188-6.075 3.798 6.075m-3.923 0 3.798-6.075m9.512 5.723s.728.595 2.05.515c.673-.04 1.603-.465 1.443-1.68-.16-1.215-2.5-1.865-2.5-1.865s-.985-.27-1-1.23a1.499 1.499 0 0 1 1.5-1.598 2.562 2.562 0 0 1 1.865.543'
            stroke='#E60000'
            strokeLinejoin='round'
          />
        </g>
        <defs>
          <clipPath id='3208399c-7f18-48d6-b1e5-a616fb8263fa__a'>
            <path d='M0 0h48v48H0z' fill='#fff' />
          </clipPath>
        </defs>
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconDocumentXls
